import React, { Component } from 'react';

import PropTypes from 'prop-types';

import ButtonLink from 'common/uiV3/Button/ButtonLink';

import LandingLogos from './LandingLogos';

import 'css/components/_LandingFooterCTA.scss';

export default class LandingFooterCTA extends Component {
  static propTypes = {
    ctaTo: PropTypes.string,
    ctaValue: PropTypes.string,
    message: PropTypes.string,
    style: PropTypes.string,
    title: PropTypes.string,
  };

  static defaultProps = {
    ctaTo: '/register',
    ctaValue: 'Get started',
    expanded: false,
    message: 'Get started with Canny for\u00a0free',
    style: 'transparent',
    title: 'Canny is built for B2B',
  };

  renderButton() {
    const { ctaValue } = this.props;

    const ctaTo = 'https://canny.io/register';

    if (ctaTo.startsWith('https://') || ctaTo.startsWith('http://')) {
      return (
        <ButtonLink rel="noopener" target="_blank" href={ctaTo} size="large">
          {ctaValue}
        </ButtonLink>
      );
    }

    return (
      <ButtonLink to={ctaTo} size="large">
        {ctaValue}
      </ButtonLink>
    );
  }

  renderTrial() {
    if (!this.props.expanded) {
      return null;
    }

    return <div className="trial">Free sign up · No credit card required</div>;
  }

  renderContent() {
    const { message, title } = this.props;

    if (!this.props.expanded) {
      return (
        <div className="footerCTA">
          <div className="mainContent">
            <div className="message">{message}</div>
            {this.renderButton()}
          </div>
        </div>
      );
    }

    return (
      <div className="footerCTA expanded">
        <div className="mainContent">
          <div className="message">
            <div className="title">{title}</div>
            <div className="description">
              The best software companies are customer-driven. Join these awesome teams who use
              customer feedback to build great&nbsp;products.
            </div>
          </div>
          <div className="CTAContainer">
            {this.renderButton()}
            {this.renderTrial()}
          </div>
        </div>
        <LandingLogos />
      </div>
    );
  }

  render() {
    const { style } = this.props;
    const className = 'landingFooterCTA ' + style;

    return <section className={className}>{this.renderContent()}</section>;
  }
}
